export enum EntityType {
  LargeShareholder = 1,
  PyramidalShareholder = 2,
  Company = 3,
  OpbCompany = 4,
  Director = 5,
  VoteProposalName = 6
}
